import { t } from 'i18next';
import { create, test, enforce, skipWhen } from 'vest';

import { FormUtils } from '@anyx/shared-utils';


import { AiAutoReplyConfigFormData } from './AIAutoReplyConfigForm';

export const validationSuite = create((data: AiAutoReplyConfigFormData) => {
  skipWhen(!data.enabled, () => {
    test('contextId', FormUtils.requiredField(t('shared.field.context.name')), () => {
      enforce(data.contextId).isNotBlank();
    });
  });
});
